import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { spring } from '../../utils/motion';
export interface SegmentOption<T extends string> {
  value: T;
  label: string;
  icon?: React.ReactNode;
  count?: number;
}
interface SegmentedControlProps<T extends string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
  layoutId: string;
  className?: string;
  size?: 'sm' | 'md';
  ariaLabel: string;
}
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  layoutId,
  className,
  size = 'md',
  ariaLabel
}: SegmentedControlProps<T>) {
  return <div role="tablist" aria-label={ariaLabel} className={twMerge('inline-flex rounded-full bg-surface-2 p-1', className)} data-id="element-820" data-mp="19vm9z3yip8bi">
      {options.map(opt => {
      const active = opt.value === value;
      return <button key={opt.value} role="tab" aria-selected={active} type="button" onClick={() => onChange(opt.value)} className={twMerge('relative flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full font-bold transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand', size === 'sm' ? 'h-8 px-3 text-[13px]' : 'h-9 px-4 text-sm', active ? 'text-ink' : 'text-ink-3 hover:text-ink-2')} data-id="element-821" data-mp="cenm1xrn8j1p">
            {active && <motion.span layoutId={layoutId} transition={spring.snappy} className="absolute inset-0 rounded-full bg-surface shadow-[0_1px_6px_rgb(0_0_0/0.08)]" data-id="element-822" data-mp="54m2a23o4ay" />}
            <span className="relative flex items-center gap-1.5" data-id="element-823" data-mp="1giushngoz4nr">
              {opt.icon}
              {opt.label}
              {opt.count !== undefined && opt.count > 0 && <span className="tabular grid h-5 min-w-5 place-items-center rounded-full bg-brand px-1.5 text-[11px] text-on-brand" data-id="element-824" data-mp="1lk20nnmqy5uy">
                  {opt.count}
                </span>}
            </span>
          </button>;
    })}
    </div>;
}